<template>
   <!-- <div v-if="pageLoading">
      <img class="_imgLoader" src="@/assets/images/loading.gif"/>
    </div>
    <div v-else> -->
     <div v-if="isFormOpened" class="relative z-50 modal" id="modal-id" aria-labelledby="modal-title" role="dialog" aria-modal="true">
              <div class="fixed inset-0 z-50 overflow-hidden">
                  <div class="absolute inset-0 transition-opacity bg-black bg-opacity-50 modal-overlay"></div>
                  <div class="p-4 mx-auto text-center animate-translate sm:max-w-lg">
                      <div class="relative overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl dark:bg-zinc-700">
                          <div class="bg-white dark:bg-zinc-700">
                            <div v-if="pageLoading">
                              <div class="mt-4"></div>
                              <Loader class=""></Loader>
                              <div class="mt-4"></div>
                            </div>
                              <div v-else class="p-5 sm:flex sm:items-finish">
                                  <div v-if="!isJobListingSent" class="w-full mt-3 text-center sm:mt-0 ltr:sm:ml-4 rtl:sm:mr-4 ltr:sm:text-left rtl:sm:text-right">
                                      <div class="mt-2">
                                          <h5 class="text-gray-900 dark:text-zinc-100/80">
                                            <b>Send to email address</b>
                                          </h5>
                                      </div>
                                      <div class="mt-4">
                                          <hr>
                                        </div>
                    
 <!-- <label for="emailInput" class="text-gray-900 dark:text-gray-50">Send to email address</label>  -->

                                        <div class="mt-4 filter-search-form mt-lg-0">
                                          <i class="uil uil-envelope"></i>

                                        <!-- Form -->

                                          <input data-test-key="input-email-subscription-email" 
                                            type="email"
                                            class="w-full filter-job-input-box dark:text-gray-100" 
                                            v-model="state.emailForm.emailAddress"
                                            placeholder="Enter your email"
                                            />
   
                                          </div>
                                          <div>
                                            <ValidationMessage v-if="v$.emailForm.emailAddress.$error" :validationMessage ="v$.emailForm.emailAddress.$errors[0].$message"/>
                                          </div>

                                          <button data-test-key="button-email-subscription-submit" 
                                            class="mt-3 w-full btn group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=sky]:bg-sky-500 group-data-[theme-color=red]:bg-red-500 group-data-[theme-color=green]:bg-green-500 group-data-[theme-color=pink]:bg-pink-500 group-data-[theme-color=blue]:bg-blue-500 border-transparent text-white hover:-translate-y-1.5"
                                            v-on:click="emailJobListingHandler()">
                                            Send <i class="uil uil-arrow-right"></i>
                                          </button>
                                      </div>
                                       <FeedbackNotification class="w-full mt-3" v-if="this.notification.text != ''" 
                                        :feedbackText="this.notification.text"
                                        :feedbackLevel="this.notification.level" />
                                    </div>
                                    <div class="px-4 py-3 bg-gray-100/50 sm:flex ltr:sm:flex-row-reverse sm:px-6 dark:bg-zinc-800">
                                  <button v-if="!isJobListingSent || !pageLoading" v-on:click="isFormOpened = false" type="button" class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm btn dark:text-gray-100 hover:bg-gray-50/50 focus:outline-none focus:ring-2 focus:ring-custom-500/20 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm dark:bg-zinc-700 dark:border-zinc-600 dark:hover:bg-zinc-600 dark:focus:bg-zinc-600 dark:focus:ring-zinc-700 dark:focus:ring-gray-500/20" data-tw-dismiss="modal">Cancel</button>
                                  <button v-else v-on:click="isFormOpened = false" type="button" class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm btn dark:text-gray-100 hover:bg-gray-50/50 focus:outline-none focus:ring-2 focus:ring-custom-500/20 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm dark:bg-zinc-700 dark:border-zinc-600 dark:hover:bg-zinc-600 dark:focus:bg-zinc-600 dark:focus:ring-zinc-700 dark:focus:ring-gray-500/20" data-tw-dismiss="modal">Continue</button>
                              </div>
                          </div>
     
                              </div>
                              </div>
                              </div>
                              </div>

</template>

<script>
import { jobListingAPI } from "@/api/jobListing";
import { useStatus } from "@/api/composables/status";
import { useErrorLogger } from "@/api/composables/errorLogging";
import { reactive, computed } from 'vue' 
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import ValidationMessage from "@/components/ValidationMessage.vue";
import FeedbackNotification from "@/components/FeedbackNotification.vue";
import Loader from "@/components/Loader.vue";

const pageStatus = useStatus();
const log = useErrorLogger();

export default {
  props: ["jobListingIdentifier"],
  components: { ValidationMessage, FeedbackNotification, Loader },
  setup () {
    const state = reactive({
      emailForm : {
        emailAddress : ''
        },
      });
      const rules = computed(() => {
        return {
          emailForm: {
            emailAddress : { required, email },
          }
        }})
      const v$ = useVuelidate(rules, state)
      return { state, v$ }
  },
  data() {
    return {
      pageLoading: false, 
      isFormOpened: true,
      isJobListingSent: false,
      notification : {
        text : "",
        level : "",
      },
    };
  },
  mounted(){

  },
  methods: {
    async emailJobListingHandler() {
      // validate the form
      this.v$.$validate();
      if(!this.v$.$error)
      {
        this.pageLoading = true;
        const result = await log.catchPromise(() =>
          pageStatus.observe(async () => {
            const result = await jobListingAPI.sendAsEmail(
              this.state.emailForm.emailAddress, 
              this.jobListingIdentifier
              );
              // success   
              if(result.data)
              {
                this.notification.text = "Job opening sent";
                this.notification.level = "success"
                this.isJobListingSent = true; 
                // notify the parent view  
                this.$emit('formsubmitted');        
              }    
            })
          );
        this.pageLoading = false;
        if (!result.success) {
          this.notification = { text : result.data, level : "error" };
        }
      }
    },
  },
};
</script>